import React from 'react'
import logo from '../assets/rem-logo.png';
import newLogo from '../assets/newHero.jpg';  

const Hero = () => {
    return (
        <div className="container 2xl:px-20 mx-auto mt-24">
            <div className="bg-gradient-to-r from-purple-800 to-purple-950 flex justify-center items-center h-100 rounded-2xl">
                <img src={logo} alt="REM Logo" className="w-100" />
            </div> 
        </div>

    )
}

export default Hero






// import React, { useEffect } from 'react';
// import 'aos/dist/aos.css'; // Import AOS CSS
// import AOS from 'aos'; // Import AOS
// import logo from '../assets/rem-logo.png';

// const Hero = () => {
//     // Initialize AOS
//     useEffect(() => {
//         AOS.init({ duration: 1000, offset: 100 }); // Customize animation duration and offset
//     }, []);

//     return (
//         <div className="container 2xl:px-20 mx-auto my-5">
//             <div
//                 className="bg-gradient-to-r from-purple-800 to-purple-950 flex justify-center items-center h-100 rounded-2xl shadow-lg"
//                 data-aos="zoom-in"
//             >
//                 <img
//                     src={logo}
//                     alt="REM Logo"
//                     className="w-100 max-w-xs md:max-w-md lg:max-w-lg"
//                     data-aos="fade-up"
//                     data-aos-delay="200"
//                 />
//             </div>
//         </div>
//     );
// };

// export default Hero;
